import { translate } from "app/filters/i18nFilter";
import { SL_IMG_LISTS } from "app/pages/sales-intelligence/pages/management/constants/constants";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { formatNumberWithCommas } from "app/pages/sales-intelligence/utils/numbers";
import { AssetsService } from "app/services/AssetsService";

import {
    SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_1,
    SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_2,
    SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_3,
} from "./constants";
import { StyledInfoWrapper, StyledList, StyledListImage, StyledLoadListInfo } from "./styles";

export const UploadInstructions = () => {
    const signalApiDomains = salesSettingsHelper.getSalesApiSignalsDomainsLimit() || 0;

    return (
        <StyledInfoWrapper>
            <StyledListImage
                src={AssetsService.assetUrl(SL_IMG_LISTS)}
                alt="suppression-list-img"
            />
            <StyledLoadListInfo>
                <StyledList>
                    <li>{translate(SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_1)}</li>
                    <li>{translate(SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_2)}</li>
                    <li>
                        {translate(SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_3, {
                            domainsCount: formatNumberWithCommas(signalApiDomains),
                        })}
                    </li>
                </StyledList>
            </StyledLoadListInfo>
        </StyledInfoWrapper>
    );
};
